import React from 'react';

import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { useAuth0 } from '@auth0/auth0-react';
import { CustomIcon } from '../../../shared/components/CustomIcon/CustomIcon';

const ProfileDropdown = () => {
  const { logout } = useAuth0();

  const onLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin
      }
    });
  };

  return (
    <Dropdown navbar={true} as="li">
      <Dropdown.Toggle
        bsPrefix="toggle"
        as={Link}
        to="#!"
        className="pe-0 ps-2 nav-link"
      >
        <CustomIcon icon="user" />
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-caret dropdown-menu-card  dropdown-menu-end">
        <div className="bg-white rounded-2 py-2 dark__bg-1000">
          <Dropdown.Item as={Link} onClick={onLogout}>
            Logout
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
